// Thin wrapper around the Meta (Facebook) Pixel's `fbq`. The pixel base code is
// injected server-side in the layout head for public visitors only (see
// ApplicationController#meta_pixel_id), so `fbq` may be absent — for signed-in
// staff, when the pixel is unconfigured, or if a blocker removed it. Every call
// here is a safe no-op in that case.
//
// We fire Meta STANDARD events so website ad campaigns can optimise for real
// business actions that happen outside Meta:
//   • Contact — a WhatsApp click or phone-call tap
//   • Lead    — any enquiry/quote form submitted
// These map to the Meta setup guide the client received:
//   Contact = WhatsApp, Contact = Phone, Lead = Form submit (any on website).

function fbqAvailable() {
  return typeof window !== "undefined" && typeof window.fbq === "function";
}

// Fire a Meta standard event. `params` is optional (e.g. { content_name }).
export function trackPixel(event, params) {
  if (!fbqAvailable()) return;
  try {
    if (params) window.fbq("track", event, params);
    else window.fbq("track", event);
  } catch {
    /* never let analytics break the page */
  }
}

// A WhatsApp click — Meta "Contact".
export function trackContactWhatsApp(params) {
  trackPixel("Contact", { contact_method: "whatsapp", ...(params || {}) });
}

// A phone-call tap (tel: link) — Meta "Contact".
export function trackContactPhone(params) {
  trackPixel("Contact", { contact_method: "phone", ...(params || {}) });
}

// A submitted enquiry / quote form — Meta "Lead".
export function trackLead(params) {
  trackPixel("Lead", params);
}

// A visit to a specific property page — Meta "ViewContent". Lets ad campaigns
// build audiences of people who viewed a property and optimise for it.
export function trackViewContent(params) {
  trackPixel("ViewContent", { content_type: "property", ...(params || {}) });
}
